import { mapValues } from '@exodus/basic-utils';
import { setAccounts } from '@exodus/multi-account-redux';
import lodash from 'lodash';
import id from './id.js';
import initialState from './initial-state.js';
import helper from './multi-account-helper.js';
import selectorDefinitions from './selectors/index.js';
const { merge } = lodash;
const mergeChanges = (balancesState, changesByWalletAccount) => {
    return {
        ...balancesState,
        ...mapValues(changesByWalletAccount, (changesByAsset, walletAccount) => {
            if (!balancesState[walletAccount]) {
                return {
                    loaded: true,
                    error: null,
                    data: mapValues(changesByAsset, (changesByField) => mapValues(changesByField, (balanceField) => balanceField.to)),
                };
            }
            const updatedData = mapValues(changesByAsset, (changesByField) => mapValues(changesByField, (balanceField) => balanceField.to));
            return {
                ...balancesState[walletAccount],
                data: merge({}, balancesState[walletAccount].data, updatedData),
            };
        }),
    };
};
const optimisticBalancesReduxDefinition = {
    id,
    type: 'redux-module',
    initialState,
    eventReducers: {
        optimisticBalances: (state, payload) => {
            const reduxState = state;
            const optimisticBalancesPayload = payload;
            const ignoreChanges = reduxState === initialState;
            if (!ignoreChanges &&
                optimisticBalancesPayload.changes &&
                Object.keys(optimisticBalancesPayload.changes).length > 0) {
                return mergeChanges(reduxState, optimisticBalancesPayload.changes);
            }
            return setAccounts(reduxState, optimisticBalancesPayload.balances);
        },
    },
    selectorDefinitions: [...helper.selectorDefinitions, ...selectorDefinitions],
};
export default optimisticBalancesReduxDefinition;
